export enum BulkRetargetingRoutes {
  LIST = '/sites/:siteId/campaigns/bulk-retargeting',
  EDIT = '/sites/:siteId/campaigns/bulk-retargeting/*',
  EDIT_AUDIENCE = '/sites/:siteId/campaigns/bulk-retargeting/:campaignId/audience',
  EDIT_CONTENT = '/sites/:siteId/campaigns/bulk-retargeting/:campaignId/content',
  EDIT_SCHEDULING = '/sites/:siteId/campaigns/bulk-retargeting/:campaignId/scheduling',
}
